import React, { useState } from "react";
import logo from "../../../assets/images/logo-main.png";
import "./style.css";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { loginMember } from "../../../services/Auth";
import { jwtDecode } from "jwt-decode";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

function Login() {
  const [formData, setFormData] = useState({
    email: "admin@cryptogt.com",
    password: "",
  });
  const [isPending, setIsPending] = useState(false);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!formData.email || !formData.password) {
      toast.warn("All fields are required!");
      return;
    }

    setIsPending(true);

    try {
      const userData = await loginMember(
        formData.email.toLowerCase(),
        formData.password
      );

      jwtDecode(userData.token);

      localStorage.setItem("userData", JSON.stringify(userData));
      localStorage.setItem("userType", userData.userType);
      toast.success("Login successful!");

      navigate("/admin/dashboard");
    } catch (error) {
      toast.error(error.message || "Login failed!");
    } finally {
      setIsPending(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  return (
    <div className="login">
      <div className="login-first">
        <img className="login-logo" alt="logo" src={logo} />
      </div>

      <div className="login-main">
        <div className="loma-first">
          <h2>Login</h2>
        </div>

        <div className="loma-second">
          <div className="input-group-2">
            <label>Email</label>
            <input
              type="email"
              name="email"
              placeholder="Enter Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-group-2 eye-parent">
            <label>Password</label>
            <input
              type={visible ? "text" : "password"}
              name="password"
              placeholder="Enter Password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <div className="eye" onClick={() => setVisible((prev) => !prev)}>
              {visible ? <AiFillEye /> : <AiFillEyeInvisible />}
            </div>
          </div>
        </div>

        <div className="loma-fourth">
          <button
            type="submit"
            onClick={handleLogin}
            disabled={isPending}
          >
            {isPending ? "Loading..." : "Login"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;
